<template>
  <div class="main">
    <p class="title">您是首次注册登录，请输入您的真实姓名</p>
    <div class="phone-wrap">
      <input class="ipt" type="text" />
    </div>
    <div @click="loginHandle" class="btn">登录</div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    loginHandle() {
      this.$router.replace("/");
    },
  },
};
</script>

<style lang="less" scoped>
.title {
  margin-top: 100px;
  font-size: 0.45rem;
}
.phone-wrap {
  border: 1px solid #eee;
  margin-top: 40px;
  width: 80%;
  height: 100px;
  margin-bottom: 20px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  padding-left: 10px;
  .ipt {
    font-size: 0.4rem;
    line-height: 50px;
    width: 100%;
    margin-left: 10px;
  }
}

.btn {
  margin-top: 40px;
  width: 80%;
  height: 80px;
  background: #006feb;
  border-radius: 10px;
  text-align: center;
  font-size: 0.35rem;
  color: #fff;
  line-height: 80px;
}
</style>